module.exports = "/_next/static/images/svgImages-ec78ba012123948a06265ac8823a5357.svg";